"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactSelect = _interopRequireDefault(require("react-select"));

var _styles = require("./styles");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var serializeSelection = function serializeSelection(o) {
  return {
    value: o.id,
    label: o.label
  };
};

var LabelsSelection = function LabelsSelection(_ref) {
  var configuration = _ref.configuration,
      labels = _ref.labels,
      onSetLabel = _ref.onSetLabel;
  var selectedLabel = configuration.map.basemap.labels;
  var selectedOption = serializeSelection(labels[selectedLabel]);
  var serialize = Object.keys(labels).map(function (basemap) {
    return serializeSelection(labels[basemap]);
  });
  return _react["default"].createElement(_reactSelect["default"], {
    onChange: function onChange(label) {
      return onSetLabel(label.value);
    },
    value: selectedOption,
    options: serialize,
    styles: _styles.InputStyles
  });
};

var _default = LabelsSelection;
exports["default"] = _default;